import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../../../services';


@Injectable()
export class LastUsedService {
  private http = inject(HttpClient);
  private _appService = inject(AppService);


  private headers = new HttpHeaders();
  private serviceUrl = this._appService.getServerBaseUrl + '/party';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.headers.append("Accept", "*/*")
    this.headers.append("Content-Type", "application/json")
  }

  getVisited(): Observable<any> {

    const url = `${this.serviceUrl}/visited`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http.get(url, options)

  }

  getMoreVisited(): Observable<any> {

    const url = `${this.serviceUrl}/morevisited`;
    let options = { headers: this.headers, withCredentials: true };
    return this.http.get(url, options)
  }
}
